export default "__VITE_ASSET__5rnZmUMz__"